import React, { useState, useEffect } from 'react';
import api from '../services/api';
import VideoSessionAssignModal from './VideoSessionAssignModal';

function VideoSessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(null);
  const [assigningSession, setAssigningSession] = useState(null);
  const [sharesBySessionId, setSharesBySessionId] = useState({});

  const fetchSharesForSessions = async (items) => {
    const entries = await Promise.all(
      items.map(async (session) => {
        try {
          const response = await api.getVideoSessionShares(session.id, 1, 100);
          return [session.id, response.items || []];
        } catch (err) {
          return [session.id, []];
        }
      })
    );
    setSharesBySessionId(Object.fromEntries(entries));
  };

  const fetchSessions = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await api.getVideoSessions(pageNum, 20, null, search, statusFilter);
      const items = response.items || [];
      setSessions(items);
      setTotalPages(response.total_pages || 0);
      setPage(pageNum);
      setError(null);
      fetchSharesForSessions(items);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSessions(1);
  }, [search, statusFilter]);

  const handleDelete = async (sessionId) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.deleteVideoSession(sessionId);
        fetchSessions(page);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
      case 'succeed': return '#4caf50';
      case 'failed': return '#f44336';
      case 'processing': return '#2196f3';
      case 'pending': return '#f0ad4e';
      default: return '#757575';
    }
  };

  return (
    <div className="content-section">
      <h1>Video Sessions</h1>

      {error && <div className="error-message">{error}</div>}

      <div className="toolbar">
        <input
          type="text"
          placeholder="Search sessions..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="search-input"
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="processing">Processing</option>
          <option value="completed">Completed</option>
          <option value="failed">Failed</option>
        </select>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Session ID</th>
                <th>User</th>
                <th>Status</th>
                <th>Questions</th>
                <th>Scoring Mode</th>
                <th>Created</th>
                <th>Assigned to</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map((session) => (
                <tr key={session.id}>
                  <td>{session.id}</td>
                  <td>{session.user_full_name || session.username}</td>
                  <td>
                    <span
                      className="status-badge"
                      style={{ backgroundColor: getStatusColor(session.status) }}
                    >
                      {session.status}
                    </span>
                  </td>
                  <td>{session.question_count}</td>
                  <td>{session.scoring_mode}</td>
                  <td>{new Date(session.created_at).toLocaleDateString()}</td>
                  <td>
                    {sharesBySessionId[session.id] === undefined
                      ? '...'
                      : sharesBySessionId[session.id].length === 0
                      ? '-'
                      : sharesBySessionId[session.id]
                          .map((share) => share.shared_with_username)
                          .join(', ')}
                  </td>
                  <td>
                    <button
                      className="btn btn-small btn-secondary"
                      onClick={() => setAssigningSession(session)}
                    >
                      Assign
                    </button>
                    {/* Tạm thời ẩn nút Delete, bật lại khi cần
                    <button
                      className="btn btn-small btn-danger"
                      onClick={() => handleDelete(session.id)}
                    >
                      Delete
                    </button>
                    */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              onClick={() => fetchSessions(page - 1)}
              disabled={page <= 1}
              className="btn btn-small"
            >
              Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button
              onClick={() => fetchSessions(page + 1)}
              disabled={page >= totalPages}
              className="btn btn-small"
            >
              Next
            </button>
          </div>
        </>
      )}

      {assigningSession && (
        <VideoSessionAssignModal
          session={assigningSession}
          onClose={() => {
            setAssigningSession(null);
            fetchSessions(page);
          }}
        />
      )}
    </div>
  );
}

export default VideoSessions;
